import React, { useEffect } from 'react';

/*Hooks*/
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

/*Components*/
import { Button, Box } from '@mui/material';

/*Actions*/
import { onImpersonationOut } from '@store/user/actions';

/*Selectors*/
import { getIsImpersonation } from '@store/user/selector';

/*Icons*/
import { IconArrowBack } from '@tabler/icons-react';

const Impersonation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isImpersonation = useSelector(getIsImpersonation);

  return (
    <Box>
      {isImpersonation && (
        <Button
          aria-label="Impersonation"
          color="inherit"
          variant="text"
          aria-controls="msgs-menu"
          aria-haspopup="true"
          sx={{
            color: 'primary.main',
          }}
          onClick={() => dispatch(onImpersonationOut())}
          startIcon={<IconArrowBack size="15" style={{ marginTop: '2px' }} />}
        >
          {t('CORE:back_admin')}
        </Button>
      )}
    </Box>
  );
};

export default Impersonation;
